/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import { permissionObj } from '../../../../../Helpers/permission';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import { EditIcon } from "../../../../../components/buttons/IconButtons";
import { EmployeeFlowContractorUpdateApp } from "../../Functionality/ContractorCreateUpdateFlows/EmployeeFlowContractorUpdateApp";
import { CommonContractorCreateUpdateApp } from "../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";

import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';
import { isValidLengthDocumentId, validateMinLengthTrimmed } from '../../../../../Apis/functions';
import { PASSWORD_MIN_LENGTH } from '../../../../../constant/variable';
import UnlinkDeviceBtn from '../../../../../components/buttons/UnlinkDeviceBtn';
import ContractorStepperWithDetails from './ContractorStepperWithDetails';
import ContractorStepperWithoutDetails from './ContractorStepperWithoutDetails';

const EmployeeFlowContractorUpdate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        params,
        permission,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        isValidPassword,
        setIsValidPassword,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,
        photoPicker,
        setPhotoPicker,
        modified,
        setModified,
        setExtraData,
        headersList, 
        extraData,
        extraDataEnabled,
        setExtraDataEnabled
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        getAllServiceType,
        goBack,
        showUnlinkBtn,
        handleChange,
    } = EmployeeFlowContractorUpdateApp({
        t,
        params,
        dispatch,
        navigate,
        workShiftsList,
        customizedList,
        setEmptyFields,
        isValidDob,
        isValidPassword,
        photoPicker,
        permission,
        setWorkShiftsList,
        setCustomizedList,
        setSecretModal,
        setSecretKey,
        setSteps,
        modified,
        setModified,
        setPhotoPicker,
        setExtraData,
        headersList, 
        extraData,
        extraDataEnabled,
        setExtraDataEnabled
    });


    if (!DEV &&
        (!permission?.includes(permissionObj.WEB_CONTRACTOR_READ) ||
            !permission?.includes(permissionObj.WEB_CONTRACTOR_UPDATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle onBack={goBack} name={t('update')}>
                {(DEV || permission?.includes(permissionObj.WEB_CONTRACTOR_UPDATE)) && (
                    <ButtonAction
                        id={'btn_efcu_update'}
                        name={'update'}
                        className={'btn-icon-edit'}
                        disabled={false}
                        Icon={EditIcon}
                        onClick={() => {
                            validateEmail(user.email);
                            validatePhone(user.phoneNumber);
                            const isValid = validateMinLengthTrimmed(user.password, {
                                minLength: PASSWORD_MIN_LENGTH,
                                allowEmpty: true,
                            });
                            const docummentIdOk = isValidLengthDocumentId(user.documentId);
                            setIsValidPassword(isValid);
                            setIsValidDocumentId(docummentIdOk);

                            if (!isValid || !docummentIdOk) return;
                            FormHandler();
                        }}
                    />
                )}
                {showUnlinkBtn && <UnlinkDeviceBtn userId={user.userId} updated={() => setModified(true)} />}
            </HeadTittle>
            {extraDataEnabled ? (
                <ContractorStepperWithDetails
                    user={user}
                    setUser={setUser}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    getAllServiceType={getAllServiceType}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    headersList={headersList}
                    handleChange={handleChange}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    disabled={disabled}
                    workShiftsList={workShiftsList}
                    setWorkShiftsList={setWorkShiftsList}
                    customizedList={customizedList}
                    setCustomizedList={setCustomizedList}
                    params={params}
                />
            ) : (
                <ContractorStepperWithoutDetails
                    user={user}
                    setUser={setUser}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    getAllServiceType={getAllServiceType}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    disabled={disabled}
                    workShiftsList={workShiftsList}
                    setWorkShiftsList={setWorkShiftsList}
                    customizedList={customizedList}
                    setCustomizedList={setCustomizedList}
                    params={params}
                />
            )}
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={'close'}
            />
        </>
    );
};

export default EmployeeFlowContractorUpdate;
